import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale } = useRouter();

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <EfSection
                title={t('M_title')}
                desc={t('M_desc')}
                pc={
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1723608668115/%E6%B2%B9%E5%8A%A8%E6%9C%BA%E6%90%AD%E9%85%8D%E5%A2%9E%E5%8A%A0%E7%BB%AD%E8%88%AA.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1724662395295/d1.jpg'
                }
                h5={
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1723608697992/%E6%B2%B9%E5%8A%A8%E6%9C%BA%E6%90%AD%E9%85%8D%E5%A2%9E%E5%8A%A0%E7%BB%AD%E8%88%AA.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1724662395431/d2.jpg'
                }
            />
        </div>
    );
}
